import { observable } from "@legendapp/state";
import { persistObservable } from "@legendapp/state/persist";
import { configureObservablePersistence } from "@legendapp/state/persist";
import { ObservablePersistLocalStorage } from "@legendapp/state/persist-plugins/local-storage";
import { ViewSettings } from "./types";

export const viewSettings$ = observable<ViewSettings>({
  showTracks: true,
  showVideo: true,
  showTrackLabels: true,
  showCameraLabel: true,
  showDebugInfo: false,
  lockCamera: false,
  syncTabs: true,
  viewMode: "snapshots",
  showCamera: true,
  showStoreModel: true,
  showDetectionCamera: true,
  showDetections: false,
  showReprojections: false,
  showUnmatchedDetections: false,
  detectionConfidence: 0.5,
  reprojectionConfidence: 0.5,
  trackConfidence: 0.5,
  showNewModel: false,
  showOverflowPoints: true,
  showTrackId: true,
  showTrackAvatar: true,
  showLastDetectionsPanel: true,
  showAbsoluteTime: true,
  showSkuSectionView: false,
  showBins: false,
  showGondolas: true,
  showPlanogramLabels: true,
  showZoneProjections: true,
  showOverflowZoneProjection: false,
  showZones: true,
});

configureObservablePersistence({
  pluginLocal: ObservablePersistLocalStorage,
});

// Persist this observable
persistObservable(viewSettings$, {
  local: "view-settings", // Unique name
});
